import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'zc-zc-widget-core',
  template: `
    <p>
      zc-widget-core works!
    </p>
  `,
  styles: []
})
export class ZcWidgetCoreComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
